export default "__VITE_ASSET__X9IhhFB2__"